import { VancouverHero } from './components/VancouverHero';
import { OwnerOccupantRules } from './components/OwnerOccupantRules';
import { LicensingProcess } from './components/LicensingProcess';
import { EnforcementPenalties } from './components/EnforcementPenalties';
import { MarketDemand } from './components/MarketDemand';
import { VancouverCTA } from './components/VancouverCTA';
import { Navbar } from '../home/components/Navbar';
import { Footer } from '../home/components/Footer';

export default function VancouverSTRPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <VancouverHero />
        <OwnerOccupantRules />
        <LicensingProcess />
        <EnforcementPenalties />
        <MarketDemand />
        <VancouverCTA />
      </main>
      <Footer />
    </div>
  );
}
